const REPORT_URLS = {
  1: "leader/audit/reports",
  2: "leader/audit/reports",
  4: "leader/audit/reports",
  7: "leader/audit/simple/insight",
  8: "leader/audit/reports/roi",
  12: "leader/audit/reports",
};

export const getReportLink = (reportId) => {
  return `${window.location.origin}/${REPORT_URLS[reportId]}`;
};
